import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-privacy-component',
  templateUrl: './privacy-component.component.html',
  styleUrls: ['./privacy-component.component.scss']
})
export class PrivacyComponentComponent implements OnInit {

  pageData: any;

  ngOnInit(): void {
    let element = document.querySelector('scrollId');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

  }

  constructor(
    private dialogRef: MatDialogRef<PrivacyComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.pageData = data;
  }

  onClose() {
    this.dialogRef.close();
  }


}
